<template>
  <div id="pCenter">
    <div class="centerBox">
      <div class="top clearfix">
        <div class="flCenter">
          <div class="left">
            <!-- <img src="@/assets/imgs/logo.png" alt=""> -->
            <a href="javascript:;" class="gobackHome" @click="goHome">返回首页</a>
          </div>
          <div class="searchBox">
            <div class="ipt">
              <input type="text" v-model="keywords" placeholder="请输入要搜索的内容">
            </div>
            <a href="javascript:;" class="search" @click="intoSearch(keywords)" target="_blank">搜索</a>

          </div>
        </div>
      </div>
      <div class="listBox inner clearfix">
        <div class="innerLeft">
          <p class="title">动态</p>
          <div class="tzList">
            <div class="newsList">
              <ul>
                <li v-for="(item,i) in threadlist" :key="i">
                  <router-link :to="{path:`/newsdetail/${item.tid}`}" target="_blank">
                      <div class="clearfix" style="display: flex;">
                        <div class="left_img" v-if="item.thumbs.length!= 0">
                          <img class="l_img" :src="item.thumbs[0]" alt="">
                        </div>
                        <div class="hasOne">
                          <h3 >{{item.subject}}</h3>
                          <div class="btm_txt">
                            <!-- <span class="tag">我是标签啊</span> -->
                            <img class="avatar" alt="" :src="item.avatar">
                            <a class="msg" href="javascript:;">{{item.author}} · {{item.replies}}条评论 · {{happenTimeFun(item.dateline)}}</a>
                          </div>
                        </div>
                      </div>
                  </router-link>
                  
                </li>

              </ul>
              <div v-if="threadlist.length>0" class="tipsTxt">
                <div v-if="!threadlistCompleted">正在加载更多内容</div>
                <div v-else  class="tipsTxt">已加载全部</div>
              </div>
              <div v-else  class="tipsTxt">暂无数据</div>
            </div>
          </div>
        </div>
        <div class="innerRight">
          <Rightbox :name="pcenter"></Rightbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import service from "@/api/service/service";
  import Header2 from "../common/header2";
  import Rightbox from "../common/loginBox";
  import {
    storageData
  } from "@/assets/js/storage";
  export default {
    components: {
      Header2,
      Rightbox,
    },
    data() {
      return {
        pcenter: this.$route.name, //获取当前页的路由name personcenter
        keywords: "",
        threadlist: [],
        page: 1, //滚动加载
        loading: false, //滚动加载
        scrolling: false, //是否是滚动
        threadlistCompleted: 1,
        userInfo: storageData.getUserInfo(),
      };
    },
    mounted() {
      // console.log(this.userInfo.openId)
      let _self = this;
      _self.getThreadList();
      window.addEventListener("scroll", () => {
        let HEAD_HEIGHT = 70;
        let TAB_HEIGHT = 65;
        if (
          document.documentElement.scrollTop +
          document.documentElement.clientHeight +
          HEAD_HEIGHT +
          TAB_HEIGHT >=
          document.documentElement.scrollHeight
        ) {
          if (this.scrolling) return;
          this.scrolling = true;
          this.loadMore(); //滚动的时候 加载更多
          let timer = setTimeout(() => {
            this.scrolling = false;
            clearTimeout(timer);
          }, 300);
        }
      });
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("scroll", () => {});
      });
      document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
    },
    methods: {
      goHome() {
        this.$router.push("/");
      },
      happenTimeFun(num) {
        //时间戳数据处理
        let date = new Date(parseInt(num) * 1000);
        //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM; //月补0
        let d = date.getDate();
        d = d < 10 ? "0" + d : d; //天补0
        let h = date.getHours();
        h = h < 10 ? "0" + h : h; //小时补0
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m; //分钟补0
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s; //秒补0
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      },
      // intoDetail(tid, url) {
        // let a = document.createElement('a');
        // if (!tid) {
        //   a.href = url
        // } else {
        //   a.href = `${this.commonIp}/v1/threads/${tid}?site_id=${this.$route.query.sid}`
        // }
        // a.target = "_blank"
        // a.click()
      // },
      intoSearch(val) {
        let routeUrl = this.$router.resolve({
          path: `/search?curtab=1&keywords=${val}&sid=${this.$route.query.sid}`,
        });
        window.open(routeUrl.href, '_blank');
      },
      getThreadList() {
        this.loading = true;
        service
          .get(
            `${this.commonIp}/v1/threads?openId=${this.userInfo.openId}&page=${
            this.page
          }`
          )
          .then((res) => {
            if (res.data.code == 200) {
              // console.log(res)
              let data = res.data.data;
              let {
                threadlist,
                hasMore
              } = data;
              this.threadlist = [...this.threadlist, ...threadlist];
              this.threadlistCompleted = hasMore === 0;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      loadMore() {
        //滚动加载
        if (this.loading || this.threadlistCompleted) return;
        this.page += 1;
        this.getThreadList();
      },
    },
  };
</script>
<style lang="less">
  @import "~@/assets/less/index.less";


  #pCenter {
    // background: #f2f2f2;
    padding-bottom: 50px;

    .centerBox {
      .top {
        width: 100%;
        .flCenter {
          width: 1060px;
          margin: 0 auto;
          padding-top: 20px;
          box-sizing: border-box;
          .left {
            .gobackHome{
              color: #d51938;
            }
            .fl();

            img {
              width: 96px;
            }
          }

          .searchBox {
            .fr();

            .ipt {
              height: 38px;
              .fl();

              input {
                outline-style: none;
                outline-width: 0px;
                text-shadow: none;
                -webkit-appearance: none;
                -webkit-user-select: text;
                outline-color: transparent;
                padding: 0 0 0 8px;
                outline: none;
                background: #f4f5f6;
                width: 227px;
                display: inline-block;
                height: 38px;
                border: 1px solid #d9d9d9;
                border-radius: 3px 0 0 3px;
                .fl();
              }
            }

            .search {
              .fl();
              width: 68px;
              height: 38px;
              border-radius: 0 3px 3px 0;
              background: #208bdc;
              display: inline-block;
              color: #fff;
              text-align: center;
              line-height: 38px;
            }
          }
        }
      }

      // .listBox{
      .inner {
        width: 1060px;
        min-width: 1060px;
        margin-top: 20px;

        .innerLeft {
          width: 740px;
          padding: 20px;
          .fl();
          background: #fff;

          .title {
            height: 40px;
            color: #ea5d3c;
            font-weight: 700;
            font-size: 18px;
            position: relative;
            border-bottom: 1px solid #efefef;
            width: 80px;
            text-align: center;
            &::after {
              content: "";
              display: block;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 80px;
              height: 2px;
              background: #ea5d3c;
            }
          }
          .tzList{
            margin-top: 10px
          }
        }

        .innerRight {
          .fr();
          width: 295px;
        }
      }

      // }
      .tzList {
        .newsList {
          .tipsTxt{
            color: #999;
            text-align: center;
          }
          li {
            border-bottom: 1px solid #f2f2f2;
            display: flex;
            .left_img {
              float: none;
              margin-right: 20px;
              flex:0 0 186px;
              img {
                width: 100%;
                height: 120px;
                object-fit: cover;
              }
            }

            .hasOne {
              float: none;
              flex:1;
              h3 {
                white-space: nowrap;
                overflow:hidden;
                text-overflow: ellipsis;
                margin: 13px 0 0 0;
                display: block;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pcenter/pcenter.vue